import React from 'react'
import { formatCurrency } from '~/src/shared/lib/formatters'
import { useCatalogController } from '~/src/features/catalog/controllers/useCatalogController'

const PRICE_RANGES = [
  { label: 'Hasta $500', min: '', max: '500' },
  { label: '$500 a $1,000', min: '500', max: '1000' },
  { label: '$1,000 a $1,500', min: '1000', max: '1500' },
  { label: 'Más de $1,500', min: '1500', max: '' },
]

export function CatalogPage() {
  const { products, query, filters, error, loading, actions } = useCatalogController()
  const logoUrl = document.body.dataset.shopLogoUrl

  function isPriceRangeActive(range) {
    return filters.min_price === range.min && filters.max_price === range.max
  }

  return (
    <div className="shop-section">
      <section className="catalog-intro">
        <div className="catalog-intro__hero">
          {logoUrl ? (
            <img className="catalog-intro__logo" src={logoUrl} alt="Perfect Scent" />
          ) : null}
          <p className="shop-kicker">Perfumería Árabe</p>
          <h1>Perfumes con presencia, carácter y una fijación que se nota.</h1>
          <p className="catalog-intro__lead">
            Explora nuestra selección y encuentra el aroma que mejor va contigo.
          </p>
          {/*<div className="catalog-intro__actions">*/}
          {/*  <a className="shop-button" href="#catalogo-productos">*/}
          {/*    Explorar catálogo*/}
          {/*  </a>*/}
          {/*  <a*/}
          {/*    className="shop-button shop-button--secondary"*/}
          {/*    href="https://wa.me/529992673153"*/}
          {/*    target="_blank"*/}
          {/*    rel="noreferrer"*/}
          {/*  >*/}
          {/*    Asesoria por WhatsApp*/}
          {/*  </a>*/}
          {/*</div>*/}
        </div>

        <div className="catalog-trustbar">
          <div className="catalog-trustbar__item">🚚 Envios a todo Mexico</div>
          <div className="catalog-trustbar__item">💳 Compra segura</div>
        </div>
      </section>

      <section className="shop-hero shop-hero--catalog">
        <div>
          <p className="shop-kicker">Encuentra tu aroma</p>
          <h2>Busca por nombre o marca y empieza tu compra.</h2>
        </div>
        <input
          className="shop-input"
          placeholder="Buscar por nombre o marca"
          value={query}
          onChange={(event) => actions.setQuery(event.target.value)}
        />
        <div className="catalog-filters">
          <div className="catalog-filters__group">
            <span className="catalog-filters__label">Género</span>
            <div className="catalog-filters__chips">
              <button
                className={filters.gender === '' ? 'catalog-filter-chip active' : 'catalog-filter-chip'}
                onClick={() => actions.handleFilterChange('gender', '')}
                type="button"
              >
                Todos
              </button>
              <button
                className={filters.gender === 'male' ? 'catalog-filter-chip active' : 'catalog-filter-chip'}
                onClick={() => actions.handleFilterChange('gender', 'male')}
                type="button"
              >
                Caballero
              </button>
              <button
                className={filters.gender === 'female' ? 'catalog-filter-chip active' : 'catalog-filter-chip'}
                onClick={() => actions.handleFilterChange('gender', 'female')}
                type="button"
              >
                Dama
              </button>
              <button
                className={filters.gender === 'unisex' ? 'catalog-filter-chip active' : 'catalog-filter-chip'}
                onClick={() => actions.handleFilterChange('gender', 'unisex')}
                type="button"
              >
                Unisex
              </button>
            </div>
          </div>
          <div className="catalog-filters__group">
            <span className="catalog-filters__label">Precio</span>
            <div className="catalog-filters__chips">
              {PRICE_RANGES.map((range) => (
                <button
                  key={`${range.min}-${range.max}`}
                  className={isPriceRangeActive(range) ? 'catalog-filter-chip active' : 'catalog-filter-chip'}
                  onClick={() => {
                    actions.handleFilterChange('min_price', range.min)
                    actions.handleFilterChange('max_price', range.max)
                  }}
                  type="button"
                >
                  {range.label}
                </button>
              ))}
            </div>
          </div>
          <button className="shop-button shop-button--secondary" onClick={actions.clearFilters} type="button">
            Limpiar filtros
          </button>
        </div>
      </section>

      {loading && <p>Cargando productos...</p>}
      {error && <p className="shop-error">{error}</p>}
      {!loading && !error && products.length === 0 ? <p>No encontramos productos con esos filtros.</p> : null}

      <div id="catalogo-productos" className="shop-grid">
        {products.map((product) => (
          <article key={product.id} className="product-card">
            <div className="product-card__media">
              {product.image_path ? <img src={product.image_path} alt={product.name} /> : <span>Sin imagen</span>}
            </div>
            <div className="product-card__body">
              <p className="product-card__maker">{product.maker}</p>
              <h2>{product.name}</h2>
              <p className="product-card__meta">{product.gender}</p>
              <p>Notas: {product.base_notes}</p>
              <div className="product-card__footer">
                <strong>{formatCurrency(product.price)}</strong>
                <button onClick={() => actions.handleAddToCart(product)}>
                  <small>Agregar al carrito</small>
                </button>
              </div>
              {/*<Link className="product-card__link" to={`/producto/${product.slug}`}>Ver detalle</Link>*/}
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}
